import { getCookie } from "../Store/Storage/Cookies";
import { HandleDeviceId } from "./Methods";

export const FilterSizeOptions = [
  { id: 1, title: 10 },
  { id: 2, title: 25 },
  { id: 3, title: 50 },
  { id: 4, title: 100 },
];
export const PasswordExp =
  // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d#$@!%&*?]{5,30}$/;
  /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])/;
export const MobileExp = /^[6-9]{1}[0-9]{9}$/;
export const EmailExp =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const FLOAT_AND_WHOLE_NUMBER_REGEX =
  /^(?:0\.(?!0{1,3}$)\d{1,3}|[1-9]\d{0,9}(?:\.\d{1,3})?)$/;

// /^(?:0\.\d{1,3}|[1-9]\d{0,9}(?:\.\d{1,3})?|\.\d{1,3})$/;

export const Item_Type_List = [
  {
    label: "Round Wire",
    value: 1,
  },
  { label: "Profile Wire", value: 2 },
];

export const userData =
  getCookie("MconnectEnergyLoginData") !== ""
    ? JSON.parse(getCookie("MconnectEnergyLoginData"))
    : null;

export const DeviceType = 3;
export const DATE_FORMAT = "YYYY-MM-DD HH:mm:ss A";

export const lengths = {
  Password: 20,
  Names: 60,
  Mobile: 10,
  EmailId: 30,
  ItemNumber: 20,
  Description: 1000,
  OTPLength: 1,
  DeviceCode: 100,
  SecretKey: 100,
  OrganizationCode: 100,
  make: 10,
  model: 100,
  threshold: 10,
  meterCode: 20,
  totalunits: 16,
};

export const year = [
  "Januray",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Augest",
  "September",
  "October",
  "November",
  "December",
];

export const sortTypeList = [
  { label: "Energy", value: "1" },
  { label: "Motor", value: "2" },
];

export const totalMinutes = Math.floor(60 / 60);
export const seconds = 60 % 60;
export const hours = Math.floor(totalMinutes / 60);
export const minutes = totalMinutes % 60;
export const headertabs = [
  {
    key: 1,
    pathname: "/dashboard",
  },
  {
    key: 2,
    pathname: "/motordashboard",
  },

  {
    key: 3,
    pathname: "/device",
  },

  {
    key: 4.1,
    pathname: "/reports/readingreport",
  },
  {
    key: 4.2,
    pathname: "/reports/consumptionreport",
  },
  {
    key: 4.3,
    pathname: "/reports/historyreport",
  },
  {
    key: 4.4,
    pathname: "/reports/notificationreport",
  },
  {
    key: 4.5,
    pathname: "/reports/failureanalysisreports",
  },
  {
    key: 4.6,
    pathname: "/reports/alertreport",
  },
  {
    key: 5,
    pathname: "/user",
  },
  {
    key: 7,
    pathname: "/aireports",
  },

  {
    key: 6,
    pathname: "/subscription",
  },
];

export const ForTypeOptions = [
  { value: "1", label: "Paramenter" },
  { value: "2", label: "Relay" },
  { value: "3", label: "Input Pin" },
];

export const RelayTypeOptions = [
  { value: "1", label: "Parameter" },
  { value: "2", label: "Input Pin" },
];

export const ThersholdOptions = [
  { value: "1", label: "High" },
  { value: "2", label: "Low" },
  { value: "3", label: "Both" },
];

export const AccessTypeOptions = [
  { value: 1, label: "Edit" },
  { value: 2, label: "View" },
];

// export const ProjectID = {
//   project_id:
//     process.env.REACT_APP_ENV === "PRODUCTION"
//       ? 3
//       : process.env.REACT_APP_ENV === "DEVELOPMENT"
//       ? 4
//       : "",
// };

export const ProjectID = {
  project_id: 3,
};
